// extracted by mini-css-extract-plugin
export default {"forget_password_page_wrapper":"ForgetPasswordPage_forget_password_page_wrapper__cErQy"};